export const WEBSITE_BUILDER_Z_LAYERS = {
  previewOuterFrame: 0,
  designSpace: {
    outerFrame: 0,
    sectionEntityFrame: 1_000_000,
    sectionEntityOverride: 1_000_001,
    overlay: 1_000_002,
    sectionEditorUI: 1_000_003,
    containerBuilderUI: 1_000_004,
    elementBuilderUI: 1_000_004,
  },
  shell: {
    underlay: 99,
    ui: 100,
  },
  portal: 101,
  dragLayer: 999,
} as const;
